import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { getExerciseById, getExercisesByMuscleGroup } from '../../utils/api';
import Detail from '../Detail';
import ExerciseVideos from '../ExerciseVideos';
import SimilarExercises from '../SimilarExercises';
import Loader from '../Loader';
const ExerciseDetail = () => {
  const [exerciseDetail, setExerciseDetail] = useState({});
  const [exerciseVideos, setExerciseVideos] = useState([]);
  const [targetMuscleExercises, setTargetMuscleExercises] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    const fetchExerciseData = async () => {
      try {
        // Fetch exercise details from local database
        const exerciseData = await getExerciseById(id);
        setExerciseDetail(exerciseData);

        // Fetch YouTube videos
        const youtubeBaseUrl = "https://www.googleapis.com/youtube/v3/search";
        const youtubeApiKey = process.env.REACT_APP_YOUTUBE_API_KEY;
        const youtubeResponse = await fetch(
          `${youtubeBaseUrl}?q=${exerciseData.name} exercise&type=video&part=snippet&maxResults=5&key=${youtubeApiKey}`
        );
        const youtubeData = await youtubeResponse.json();

        const formattedVideos = youtubeData.items.map((item) => ({
          video: {
            videoId: item.id.videoId,
            title: item.snippet.title,
            thumbnails: [{ url: item.snippet.thumbnails.high.url }],
            channelName: item.snippet.channelTitle,
          },
        }));
        setExerciseVideos(formattedVideos);

        // Fetch similar exercises by muscle group
        const similarExercisesData = await getExercisesByMuscleGroup(exerciseData.muscleGroup);
        setTargetMuscleExercises(similarExercisesData.filter(ex => ex._id !== id)); // Exclude current exercise
      } catch (error) {
        console.error('Error fetching exercise data:', error);
      }
    };

    fetchExerciseData();
  }, [id]);

  if (!exerciseDetail || Object.keys(exerciseDetail).length === 0) return <Loader />;

  return (
    <Box sx={{ mt: { lg: '96px', xs: '60px' } }}>
      <Detail exerciseDetail={exerciseDetail} />
      <ExerciseVideos exerciseVideos={exerciseVideos} name={exerciseDetail.name} />
      <SimilarExercises targetMuscleExercises={targetMuscleExercises} />
    </Box>
  );
};

export default ExerciseDetail;